export default __webpack_public_path__ + "static/media/orgEjyc.7b12f482.png";